import React from 'react';
import Title from '../Components/Elements/Title';
import Text from '../Components/Elements/Text';
import MainContainer from '../Components/Elements/MainContainer';
import { Helmet } from 'react-helmet';
import { VerticalTimeline }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import TimelineElement from '../Components/Elements/TimelineElement';
import { observer } from 'mobx-react-lite';
import { useStore } from '../Stores/store';
import { Link } from 'react-router-dom';

interface Props {
    useHelm? : boolean;}

const Agenda = observer(({ useHelm = false} : Props) => {
    const { generalStore } = useStore();
    const { userType } = generalStore;

    return (
        <MainContainer className="sm:w-[75%] lg:w-[60%] flex justify-center flex-col mx-auto">
            {useHelm && (
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>H&R Wedding | Agenda</title>
                </Helmet>
            )}
            <Title size="2">Agenda</Title>
            <Text>Here is an overview of the main events for the day.</Text>
            <VerticalTimeline
                layout="1-column-left"
                lineColor='rgb(30, 58, 138, 0.7)'>
                <TimelineElement
                    title="Guests Arrive"
                    time="12:30"
                    userType={userType}
                    isDay />
                <TimelineElement
                    title="Ceremony"
                    time="13:00"
                    userType={userType}
                    isDay />
                <TimelineElement
                    title='Drinks, Canapes & Entertainment'
                    time='14:00'
                    userType={userType}
                    isDay />
                <TimelineElement
                    title='Head to main dining room'
                    time='15:45'
                    userType={userType}
                    isDay />
                <TimelineElement
                    title='Speeches'
                    time='18:00'
                    userType={userType}
                    isDay />
                <TimelineElement
                    title='Evening Guests Arrive'
                    time='19:00'
                    userType={userType} />
                <TimelineElement
                    title='First dance & Cake!'
                    time='19:35'
                    userType={userType} />
                <TimelineElement
                    title='Party Time'
                    time='19:45'
                    userType={userType} />
                <TimelineElement
                    title='Carriages'
                    time='00:30'
                    userType={userType} />
            </VerticalTimeline>
            { useHelm && <Text className="pt-4">
                <Link
                    to="/app"
                    className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                >
                    Back to home
                </Link>
            </Text>}
        </MainContainer>
    )
})

export default Agenda;  